import React from 'react'
import { Box, Flex, Text } from '@workwhile/ui'
import { Link } from 'react-router-dom'
import { CalendarClock, FileText } from 'lucide-react'
import * as ROUTES from 'constants/routes'
import { Header } from 'components/Header'
import { AccordionCard } from 'components/AccordionCard'

export const Fieldglass = () => {
  return (
    <>
      <Header title="Fieldglass" />
      <Box margin={3}>
        <Flex gap={3} flexWrap="wrap">
          <Link
            to={ROUTES.FIELDGLASS_SHIFT_ISSUES}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <CalendarClock size={14} />
                  <Text fontSize={2} color="lightText">
                    Shift Issues
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Shifts whose Fieldglass export, documents or timesheets need
                manual intervention.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.FIELDGLASS_JOB_POSTING}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <FileText size={14} />
                  <Text fontSize={2} color="lightText">
                    Job Posting
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                View a job posting mapped shifts, workers, and open issues.
              </Text>
            </AccordionCard>
          </Link>
        </Flex>
      </Box>
    </>
  )
}
